import { Divider, Row, Space } from "antd";
import React from "react";
import DryAutoRefractionPrint from "./DryAutoRefraction/DryAutoRefraction";
import VisualAcuityPrint from "./VisualAcuity/VisualAcuity";
import Pgp1Print from "./pgp/pgp1/pgp1";
import Pgp3Print from "./pgp/pgp3/pgp3";
import Pgp2Print from "./pgp/pgp2/pgp2";
import NearPgpPrint from "./NearPgp/NearPgp";
import SpectaclesConditionPrint from "./SpectaclesCondition/SpectaclesCondition";
import DryNetRetinoscopyPrint from "./DryNetRetinoCopy/DryNetRetinoCopy";
import DryRefractionPrint from "./DryRefraction/DryRefraction";
import DilatedAutoRefractionPrint from "./DilatePatient/DilatedAutoRefraction/DilatedAutoRefraction";
import DilatedNetRetinoscopyPrint from "./DilatePatient/DilatedNetRetinoscopy/DilatedNetRetinoscopy";
import DilatedRefractionPrint from "./DilatePatient/DilatedRefraction/DilatedRefraction";
import PmtAutoRefractionPrint from "./DilatePatient copy/PmtAutoRefraction/pmtAutoRefraction";
import PmtNetRetinoscopyPrint from "./DilatePatient copy/PmtNetRetinoscopy/PmtNetRetinoscopy";
import PmtRefractionDtosPrint from "./DilatePatient copy/PmtRefraction/PmtRefraction";
import GlassesPrescriptionPrint from "./GlassesPrescription/GlassesPrescription";

const ContentPrint = ({ detailPhieu }) => {
  return (
    <Row>
      <Space direction="vertical" split={<Divider />}>
        {(detailPhieu?.dryAutoRefractionDtos?.right ||
          detailPhieu?.dryAutoRefractionDtos?.left) && (
          <DryAutoRefractionPrint data={detailPhieu.dryAutoRefractionDtos} />
        )}

        {(detailPhieu?.visualAcuityDtos?.left ||
          detailPhieu?.visualAcuityDtos?.right) && (
          <VisualAcuityPrint detail={detailPhieu} />
        )}
        {/*   */}
        {(detailPhieu?.pgp1?.left || detailPhieu?.pgp1?.right) && (
          <Pgp1Print data={detailPhieu?.pgp1} />
        )}
        {(detailPhieu?.pgp2?.left || detailPhieu?.pgp2?.right) && (
          <Pgp2Print data={detailPhieu?.pgp2} />
        )}
        {(detailPhieu?.pgp3?.left || detailPhieu?.pgp3?.right) && (
          <Pgp3Print data={detailPhieu?.pgp3} />
        )}
        {/*  */}
        {(detailPhieu?.nearPGPDto?.left || detailPhieu?.nearPGPDto?.right) && (
          <NearPgpPrint data={detailPhieu?.nearPGPDto} />
        )}

        {/* SpectaclesConditionPrint */}
        {detailPhieu?.spectaclesConditionDto && (
          <SpectaclesConditionPrint data={detailPhieu.spectaclesConditionDto} />
        )}

        {/*  dry net restinoscopy*/}
        {(detailPhieu?.drynetNetRetinoscopy?.left ||
          detailPhieu?.drynetNetRetinoscopy?.right) && (
          <DryNetRetinoscopyPrint data={detailPhieu?.drynetNetRetinoscopy} />
        )}

        {/*  dry auto refraction*/}
        {(detailPhieu?.dryRefraction?.left ||
          detailPhieu?.dryRefraction?.right) && (
          <DryRefractionPrint data={detailPhieu?.dryRefraction} />
        )}

        {/* Dilated */}

        {(detailPhieu?.dilatedAutoRefractionDtos?.left ||
          detailPhieu?.dilatedAutoRefractionDtos?.right) && (
          <DilatedAutoRefractionPrint
            data={detailPhieu?.dilatedAutoRefractionDtos}
          />
        )}
        {(detailPhieu?.dilatedNetRetinoscopyDtos?.left ||
          detailPhieu?.dilatedNetRetinoscopyDtos?.right) && (
          <DilatedNetRetinoscopyPrint
            data={detailPhieu?.dilatedNetRetinoscopyDtos}
          />
        )}
        {(detailPhieu?.dilatedRefractionDtos?.left ||
          detailPhieu?.dilatedRefractionDtos?.right) && (
          <DilatedRefractionPrint data={detailPhieu?.dilatedRefractionDtos} />
        )}
        {/*  PMT */}
        {(detailPhieu?.pmtAutoRefractionDtos?.left ||
          detailPhieu?.pmtAutoRefractionDtos?.right) && (
          <PmtAutoRefractionPrint data={detailPhieu?.pmtAutoRefractionDtos} />
        )}
        {(detailPhieu?.pmtNetRetinoscopyDtos?.left ||
          detailPhieu?.pmtNetRetinoscopyDtos?.right) && (
          <PmtNetRetinoscopyPrint data={detailPhieu?.pmtNetRetinoscopyDtos} />
        )}
        {(detailPhieu?.pmtRefractionDtos?.left ||
          detailPhieu?.pmtRefractionDtos?.right) && (
          <PmtRefractionDtosPrint data={detailPhieu?.pmtRefractionDtos} />
        )}

        {(detailPhieu?.glassesPrescriptionDto?.left ||
          detailPhieu?.glassesPrescriptionDto?.right) && (
          <GlassesPrescriptionPrint
            detailPhieu={detailPhieu?.glassesPrescriptionDto}
          />
        )}
      </Space>
    </Row>
  );
};

export default ContentPrint;
